module.exports = __webpack_public_path__ + "static/media/symbol_sdf.fragment.a629e018.glsl";